<template>
  <main>
    <section class="hero">
      <div class="hero-content">
        <h2>Contact Us</h2>
        <p>We'd love to hear from you</p>
      </div>
    </section>

    <section class="content-section">
      <div class="container">
        <h2 style="text-align: center;">Get in Touch</h2>
        <p style="text-align: center; margin-bottom: 3rem;">For now, please email us directly at <strong>info@spacecoaststem.org</strong></p>
        
        <div class="info-cards">
          <div class="program-card">
            <h3>Email</h3>
            <p>General inquiries:<br><strong>info@spacecoaststem.org</strong></p>
            <p>Donations & partnerships:<br><strong>donations@spacecoaststem.org</strong></p>
          </div>

          <div class="program-card">
            <h3>Location</h3>
            <p>Serving all of Brevard County, Florida</p>
            <p>We work with schools and community centers throughout the county to bring our programs directly to students.</p>
          </div>

          <div class="program-card">
            <h3>Office Hours</h3>
            <p><strong>Monday - Friday</strong><br>9:00 AM - 5:00 PM EST</p>
            <p>We respond to all inquiries within 1-2 business days.</p>
          </div>
        </div>
      </div>
    </section>

    <section class="content-section faq-section">
      <div class="container">
        <h2>Frequently Asked Questions</h2>

        <h3>How do students apply for a laptop?</h3>
        <p>Students or their parents/guardians can <router-link to="/request">submit a request online</router-link></p>

        <h3>What types of computers can I donate?</h3>
        <p>We primarily accept laptops in working condition. Desktop computers, monitors, and other equipment may also be useful. Visit our <router-link to="/donate">Donate Equipment page</router-link>.</p>

        <h3>What are the eligibility requirements to reveive a laptop?</h3>
        <p> We do not do any formal verification of need, and we hope we never have to. We trust teachers on the platform to help identify and prioritize students who need devices since they are the ones who work with them every day. </p>

        <h3>Do you pick up donated computers?</h3>
        <p>Yes! For larger donations or donors within Brevard County, we can often arrange pickup. Contact us to coordinate the details.</p>

        <h3>Are donations tax-deductible?</h3>
        <p>Yes. Space Coast STEM is a 501(c)(3) tax-exempt nonprofit organization, so donations are tax-deductible to the extent allowed by law. We can provide a receipt for your records.</p>

        <h3>What happens to my data when I donate a computer?</h3>
        <p>We completely wipe all hard drives using secure data erasure methods before any device is refurbished. Your personal data is permanently removed and cannot be recovered.</p>

        <h3>How can my company partner with Space Coast STEM?</h3>
        <p>We offer various partnership opportunities. Email us at info@spacecoaststem.org with "Partnership Inquiry" in the subject line.</p>
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
// Contact view
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=Inter:wght@400;500;600&display=swap');

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero {
  background: linear-gradient(135deg, var(--primary-color, #2c4a6b) 0%, var(--secondary-color, #3ba3d1) 100%);
  color: var(--white, #ffffff);
  padding: 8rem 2rem;
  text-align: center;
}

.hero-content h2 {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: 700;
  font-family: 'Poppins', sans-serif;
}

.hero-content p {
  font-size: 1.3rem;
  opacity: 0.95;
}

.content-section {
  padding: 5rem 2rem;
}

.content-section h2 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  color: var(--primary-color, #2c4a6b);
  font-family: 'Poppins', sans-serif;
}

.content-section h3 {
  font-size: 1.5rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
  color: var(--secondary-color, #3ba3d1);
  font-family: 'Poppins', sans-serif;
}

.content-section p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: var(--text-light, #666666);
  margin-bottom: 1rem;
}

.faq-section {
  background: var(--white, #ffffff);
}

.info-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin: 3rem 0;
}

.program-card {
  background: var(--white, #ffffff);
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.program-card h3 {
  color: var(--primary-color, #2c4a6b);
  margin: 0 0 1rem 0;
  font-family: 'Poppins', sans-serif;
}

.program-card p {
  color: var(--text-light, #666666);
  line-height: 1.6;
}

@media (max-width: 768px) {
  .hero-content h2 {
    font-size: 2rem;
  }

  .hero {
    padding: 4rem 2rem;
  }

  .content-section h2 {
    font-size: 2rem;
  }

  .info-cards {
    grid-template-columns: 1fr;
  }
}
</style>
